import { lazy } from "react";
import { Navigate } from "react-router-dom";

import SettingsIcon from "@mui/icons-material/Settings";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";

const CityList = lazy(() => import("../components/cityList"));
const City = lazy(() => import("../components/city"));
const CityEditView = lazy(() => import("../components/cityEditView"));

const cityRoute = {
  icon: SettingsIcon,
  name: "Settings",
  link: "/settings",
  path: "settings",
  index: 25,
  children: [
    {
      path: "cities",
      element: <CityList />,
      name: "Cities",
      link: "/settings/cities",
      icon: AddLocationAltIcon,
      permission: "Cities-Read",
      index: 0,
    },
    {
      path: "cities/create",
      element: <City />,
    },
    {
      path: "cities/:id",
      element: <CityEditView />,
    },
    {
      path: "",
      element: <Navigate to="cities" replace />,
    },
  ],
};
export default cityRoute;
